import { useCallback } from 'react';
import {
  Button,
  ButtonSizeMD,
  ButtonVariants,
} from '@picsart/design-system/components/Button';
import {
  InlineButton,
  InlineButtonAlignments,
  ControlSizesMD,
} from '@picsart/design-system/components/InlineButton';
import { IconDelete } from '@picsart/design-system/foundation/icons/IconDelete';
import { IconLogout } from '@picsart/design-system/foundation/icons/IconLogout';

import { ErrorColors } from '@picsart/design-system/foundation/errorColors';
import { logout, deleteAccount } from '@/utils/user/authActions';
import useStyles from './styles';

interface SettingsActionsProps {
  isAuthorized: boolean;
}

const SettingsActions = ({ isAuthorized }: SettingsActionsProps) => {
  const classes = useStyles();

  const handleLogout = useCallback(() => logout(), []);
  const handleDeleteAccount = useCallback(() => deleteAccount(), []);

  if (!isAuthorized) return null;

  return (
    <div className={classes.actions}>
      <Button
        dataTestId="genai-settings-delete-account"
        skin={ErrorColors}
        variant={ButtonVariants.Filled}
        size={ButtonSizeMD}
        startIcon={IconDelete}
        isFullWidth
        onClick={handleDeleteAccount}
      >
        Delete account
      </Button>
      <InlineButton
        className={classes.logoutButton}
        dataTestId="genai-settings-log-out"
        size={ControlSizesMD}
        startIcon={IconLogout}
        alignment={InlineButtonAlignments.Start}
        isFullWidth
        isWithoutBorder
        isWithoutBackground
        onClick={handleLogout}
      >
        Log Out
      </InlineButton>
    </div>
  );
};

export default SettingsActions;
